import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

// Função para aplicar máscara de telefone brasileiro
const applyPhoneMask = (value) => {
  // Remove tudo que não é dígito
  let cleanValue = value.replace(/\D/g, '');
  
  // Se começar com 55, remove para aplicar a máscara local
  if (cleanValue.startsWith('55')) {
    cleanValue = cleanValue.substring(2);
  }
  
  // Aplica a máscara baseada no tamanho
  if (cleanValue.length <= 2) {
    return `+55 ${cleanValue}`;
  } else if (cleanValue.length <= 7) {
    return `+55 ${cleanValue.substring(0, 2)} ${cleanValue.substring(2)}`;
  } else if (cleanValue.length <= 11) {
    return `+55 ${cleanValue.substring(0, 2)} ${cleanValue.substring(2, 7)}-${cleanValue.substring(7)}`;
  } else {
    // Limitar a 11 dígitos
    cleanValue = cleanValue.substring(0, 11);
    return `+55 ${cleanValue.substring(0, 2)} ${cleanValue.substring(2, 7)}-${cleanValue.substring(7)}`;
  }
};

// Componente para aplicar máscara em inputs de telefone/whatsapp
const PhoneNumberMask = React.forwardRef(function PhoneNumberMask(props, ref) {
  const { onChange, name, value, ...other } = props;
  
  const handleChange = (e) => {
    const inputValue = e.target.value;
    const maskedValue = applyPhoneMask(inputValue);
    
    // Criar evento sintético com valor mascarado
    const syntheticEvent = {
      target: {
        name,
        value: maskedValue
      }
    };
    
    if (onChange) {
      onChange(syntheticEvent);
    }
  };

  return (
    <input
      {...other}
      ref={ref}
      value={value || ''}
      onChange={handleChange}
      type="tel"
      style={{
        width: '100%',
        border: 'none',
        outline: 'none',
        padding: 0,
        margin: 0,
        fontSize: 'inherit',
        fontFamily: 'inherit',
        color: 'inherit',
        backgroundColor: 'transparent',
      }}
    />
  );
});

PhoneNumberMask.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

// Componente de TextField com máscara para telefone
export const PhoneTextField = ({ label, value, onChange, name, placeholder, required, error, helperText, ...props }) => {
  return (
    <TextField
      fullWidth
      label={label}
      value={value || ''}
      onChange={onChange}
      name={name}
      placeholder={placeholder || '+55 XX XXXXX-XXXX'}
      required={required}
      error={error}
      helperText={helperText}
      InputProps={{
        inputComponent: PhoneNumberMask,
      }}
      {...props}
    />
  );
};

// Exporta tanto o componente de máscara quanto o TextField pronto
export default PhoneNumberMask;